import { useEffect, useState } from 'react';

export const useAdBlockDetect = (): boolean => {
  const [isAdBlockerDetected, setAdBlockerDetected] = useState<boolean>(false);

  useEffect(() => {
    let isFetched = true;

    const fetchAds = async () => {
      await fetch('https://tpc.googlesyndication.com', { mode: 'no-cors' });

      if (isFetched) {
        setAdBlockerDetected(false);
      }
    };

    fetchAds().catch(() => {
      setAdBlockerDetected(true);
    });

    return () => {
      isFetched = false;
    };
  }, []);

  return isAdBlockerDetected;
};
